export default __webpack_public_path__ + "static/media/shape02.2a5e45b2.png";